"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher = /** @class */ (function () {
    function EventDispatcher(logger) {
        this.dispatchMap = Object.create(null);
        this.logger = logger;
    }
    EventDispatcher.prototype.registerHandler = function (rawkey, handler, sender) {
        var key = this.initKey(rawkey);
        var record = { handler: handler, sender: sender };
        this.dispatchMap[key].push(record);
        this.logger.info('EventDispatcher:registerHandler', key, record);
    };
    EventDispatcher.prototype.dispatch = function (event) {
        this.logger.info('EventDispatcher:dispatch', event);
        for (var _i = 0, _a = this.dispatchMap[event.origin]; _i < _a.length; _i++) {
            var record = _a[_i];
            record.sender.send(record.handler.convert(event));
        }
    };
    EventDispatcher.prototype.initKey = function (rawkey) {
        var key = rawkey[0];
        if (!(key in this.dispatchMap)) {
            this.dispatchMap[key] = [];
        }
        return key;
    };
    return EventDispatcher;
}());
exports.default = EventDispatcher;
